import React, { useState } from 'react';
import classNames from 'classnames';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import InnerFactoryAuthBox from './InnerFactoryAuthBox';

const FactoryAuthContent = ({ childsAuth, factoryAuth, selectAuth, setSelectAuth }) => {
  const [viewInnerFactory, setViewInnerFactory] = useState(false);
  const handleInnerFactoryComponent = () => {
    setViewInnerFactory((_viewInnerFactory) => {
      return !_viewInnerFactory;
    });

    setSelectAuth(factoryAuth);
  };

  return (
    <>
      <OverlayTrigger key={'bottom'} placement={'bottom'} overlay={<Tooltip id={`tooltip`}>{factoryAuth.memo}</Tooltip>}>
        <div
          className={classNames('content', selectAuth && selectAuth.authIdx === factoryAuth.authIdx && 'on')}
          onClick={() => {
            handleInnerFactoryComponent();
          }}
        >
          {viewInnerFactory ? '▼' : '▶'} {factoryAuth.authNm} - {factoryAuth.memo}
        </div>
      </OverlayTrigger>
      {viewInnerFactory && <InnerFactoryAuthBox childsAuth={childsAuth} selectAuth={selectAuth} setSelectAuth={setSelectAuth} />}
    </>
  );
};

export default FactoryAuthContent;
